<div class="universal-search" [class.universal-search--open]="isDropdownOpen">
    <div class="universal-search__control">
        <span class="universal-search__icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z" stroke="currentColor" stroke-width="1.75"/>
                <path d="M21 21l-4.3-4.3" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
            </svg>
        </span>
        <input
            #searchInput
            type="search"
            class="universal-search__input"
            [value]="query"
            (input)="onQueryInput($any($event.target).value)"
            (focus)="onFocus()"
            (keydown)="onKeyDown($event)"
            [attr.aria-expanded]="isDropdownOpen"
            aria-autocomplete="list"
            [attr.aria-controls]="resultsId"
            [attr.aria-activedescendant]="highlightedIndex !== null ? resultsId + '-option-' + highlightedIndex : null"
            role="combobox"
            autocomplete="off"
            [placeholder]="placeholderText"
            [attr.aria-label]="'UniversalSearchPlaceholder' | localize"
        />
        <button
            *ngIf="query"
            type="button"
            class="universal-search__clear"
            (click)="clearQuery($event)"
            [attr.aria-label]="'Clear' | localize">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div
        *ngIf="isDropdownOpen"
        [id]="resultsId"
        class="universal-search__dropdown"
        role="listbox"
        [attr.aria-label]="'UniversalSearchResults' | localize">

        <div *ngIf="uiState === 'loading'" class="universal-search__status">
            {{ 'UniversalSearchLoading' | localize }}
        </div>

        <div *ngIf="uiState === 'error'" class="universal-search__status universal-search__status--error" role="alert">
            {{ 'UniversalSearchError' | localize }}
        </div>

        <div *ngIf="uiState === 'empty'" class="universal-search__status">
            {{ 'UniversalSearchNoMatches' | localize }}
        </div>

        <ng-container *ngIf="uiState === 'results' || (uiState === 'error' && groups.length)">
            <section
                *ngFor="let group of groups; let groupIndex = index; trackBy: trackByGroup"
                class="universal-search__group">
                <h3 class="universal-search__group-title">{{ group.category }}</h3>
                <button
                    type="button"
                    *ngFor="let item of group.items; let itemIndex = index; trackBy: trackByItem"
                    class="universal-search__option"
                    role="option"
                    [id]="resultsId + '-option-' + getFlatIndex(groupIndex, itemIndex)"
                    [class.universal-search__option--active]="highlightedIndex === getFlatIndex(groupIndex, itemIndex)"
                    [attr.aria-selected]="highlightedIndex === getFlatIndex(groupIndex, itemIndex)"
                    (click)="onResultClick(item)"
                    (mouseenter)="onResultMouseEnter(getFlatIndex(groupIndex, itemIndex))">
                    <span class="universal-search__option-media" aria-hidden="true">
                        <img
                            *ngIf="item.customImage"
                            class="universal-search__option-image"
                            [src]="item.customImage"
                            alt="" />
                        <i
                            *ngIf="!item.customImage && item.icon"
                            class="universal-search__option-icon menu-link-icon"
                            [ngClass]="item.icon"></i>
                    </span>
                    <span class="universal-search__option-text">
                        <span class="universal-search__option-title" [innerHTML]="item.title | highlightSearch:query"></span>
                        <span
                            *ngIf="item.subtitle"
                            class="universal-search__option-subtitle"
                            [innerHTML]="item.subtitle | highlightSearch:query"></span>
                    </span>
                </button>
            </section>
        </ng-container>
    </div>
</div>
